import styled from 'styled-components';

export const ColorArea = styled.div`
  width: 10px;
  height: 60px;

  ${(props) => props.color && `background-color: ${props.color};`}
`;
